module.exports = __webpack_public_path__ + "img/Packaging-2.2dd15edf.svg";